// extracted by mini-css-extract-plugin
module.exports = {"featuredResources":"styles_featuredResources__10VzX","rows":"styles_rows__1cHEY","grid":"styles_grid__2EGiw"};